import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from "./context/ThemeContext";

if (process.env.NODE_ENV === 'production') {
  ['log', 'info', 'debug', 'warn', 'error'].forEach((methodName) => {
    console[methodName] = () => {};
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
